import $ from 'qwery';

export function autoCompleteForm (config) {
    for (const key in config) {
        if (config.hasOwnProperty(key)) {
            const el = $(key)[0];
            const value = config[key];

            if (value === false) {
                el.removeAttribute('checked');
            } else if (value === true) {
                el.setAttribute('checked', 'checked');
            } else {
                el.value = value;
            }
        }
    }
}

function autoCompleteFormEvent (event) {
    const config = event.currentTarget.getAttribute('data-form-autocompleter');

    if (config) {
        autoCompleteForm(JSON.parse(config));
    }
}

(function init () {
    $('[data-form-autocompleter]').forEach(formAutocompleter => {
        formAutocompleter.addEventListener('click', autoCompleteFormEvent, false);
    });
}());
